import { render, staticRenderFns } from "./NuxtPictureExt.vue?vue&type=template&id=78bf8146&"
import script from "./NuxtPictureExt.vue?vue&type=script&lang=js&"
export * from "./NuxtPictureExt.vue?vue&type=script&lang=js&"
import style0 from "./NuxtPictureExt.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports